import { useLang } from '@/i18n';
import EfModal from '@elem/ui/ef-modal';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperTab from '@elem/ui/ef-swiper-tab';
// import EfTitle from '@elem/ui/ef-title';
import EfInfoSection from 'elem/ui/ef-info-section';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { imgLocaleA, imgLocaleB, imgLocaleC, imgLocaleD } from './Imgs';
import Modal from './Modal';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.TabC');
    const { locale = 'us' } = useRouter();
    const [gap, setGap] = useState(24);
    const [isClient, setIsClient] = useState(false);
    const [active, setActive] = useState(0);
    const [showModal, setShowModal] = useState(false);

    const configs = {
        theme: 'white',
        loop: true,
        navigation: false,
        pagination: false,
        lists: [
            {
                tab: t('a_tab'),
                desc: t('a_desc'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737007865922/AC_charging.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1737007869758/AC_charging_m.jpg',
                customizedEl: <EFXStream className="x-stream" color="#fff" />,
            },
            {
                tab: t('b_tab'),
                tabName: t('b_tab'),
                desc: t('b_desc'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737008816102/solar.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1737008820409/solar_m.jpg',
            },
            {
                tab: t('c_tab'),
                desc: t('c_desc'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737008984552/car.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1737008987470/car_m.jpg',
            },
            {
                tab: t('d_tab'),
                desc: t('d_desc'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737009119626/generator.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1737009125562/generator_m.jpg',
            },
        ],
        callback: (index) => setActive(index),
    };

    const icon = (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="36" height="36" rx="18" fill="url(#paint0_linear_1272_6517011)" />
            <path d="M25.2833 18.5001H10.7167" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 11.2168V25.7834" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_1272_6517011" x1="5.07599e-06" y1="5.30002" x2="26.6868" y2="-1.27879" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#3F68E0" />
                    <stop offset="1" stopColor="#7D9DFC" />
                </linearGradient>
            </defs>
        </svg>
    );

    const openModal = () => {
        setShowModal(true);
        const item = configs?.lists[active];
        window?.dataLayer?.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: item.tab,
            button_name: t('btn1'),
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth > 1440 ? 24 : window?.innerWidth > 1024 ? 16 : 0);
            setIsClient(true);
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            {/* <EfTitle hasAnimation={false}>{t('title')}</EfTitle> */}
            <EfInfoSection label={t('label')} title={t('title')} />
            <EfSwiperTab {...configs} gap={gap} />
            <button className="btn" onClick={openModal}>
                <span className="text">{t('btn1')}</span>
                {icon}
            </button>
            {showModal && (
                <EfModal position="center" open={showModal} className="modal muti-col" callback={() => setShowModal(false)}>
                    <Modal />
                </EfModal>
            )}
        </div>
    );
}
